module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div name=\"form-content\" class=\"wh100 add-layer\">\n    <div class=\"add-layer-top\">\n        <div>\n            <h2>\n                ")
    ; __append(escapeFn( widget.title ))
    ; __append("\n                <span class='add-layer-steps'>\n                    Шаг:\n                    <span name=\"current-step\" class='add-layer-steps-current'>\n                        ")
    ; __append(escapeFn( widget.pagerPath.indexOf(widget.pagerCurrentPage) + 1 ))
    ; __append("\n                    </span>\n                    <span name=\"steps\" class='add-layer-steps-last'>\n                        ")
    ; __append(escapeFn( widget.pagerPath.length ))
    ; __append("\n                    </span>\n                </span>\n            </h2>\n        </div>\n        <div name=\"page\"></div>\n    </div>\n    <div class=\"footer\">\n        <div name=\"back\" class=\"add-layer-next-step button\" on-click=\"onBackClick\">Назад</div>\n        <div name=\"next\" class=\"add-layer-next-step button\" on-click=\"onNextClick\">Продолжить</div>\n    </div>\n</div>")
  }
  return __output.join("");

}